export default "__VITE_ASSET__de7e0b51__"